export type TarotPreviewMode = 'one' | 'three' | 'yesno';

export const TAROT_PHASE_LABELS: Record<TarotPreviewMode, string[]> = {
  one: ['REFLECTION PROMPT'], three: ['PAST PATTERN TO REVIEW', 'PRESENT QUESTION', 'NEXT STEP TO TEST'],
  yesno: ['SYMBOLIC YES / NO'],
};
export const TAROT_READING_TITLES: Record<TarotPreviewMode, string> = {
  one: 'One theme. One question. One small action.',
  three: 'Review the past. Examine the present. Test a next step.',
  yesno: 'A symbolic answer. A real-world check.',
};

export function tarotNextStep(mode: TarotPreviewMode, meaning: string, answer = 'pause') {
  if (mode === 'yesno') {
    if (answer === 'yes') return 'The card offers a symbolic “yes,” not evidence that the outcome will happen. Try one reversible next step and check the real response before committing.';
    if (answer === 'no') return 'The card offers a symbolic “no,” not proof of a future refusal. Check the boundary, timing, or missing condition before deciding.';
    return 'Use “pause” as a prompt to gather one missing fact or have one clarifying conversation. A random card cannot determine the outcome.';
  }
  return mode === 'three'
    ? `A scenario to explore, not a predicted outcome: ${meaning} Choose one small action from this theme and compare what actually happens with your expectations.`
    : `Use this theme as a reflection prompt: ${meaning} Identify one situation where it fits, one where it does not, and one small action you can test.`;
}

export function tarotPhaseCopy(mode: TarotPreviewMode, index: number, name: string, meaning: string) {
  if (mode === 'three') {
    if (index === 0) return `A past pattern to review: ${meaning} Does this match a specific experience? If not, do not force the connection.`;
    if (index === 1) return `A present question to examine: ${meaning} Check it against the facts of your situation, not just the card.`;
    return `A possible response to test, not a forecast: ${meaning} What would one reversible step look like in your situation?`;
  }
  return mode === 'yesno'
    ? `${name} frames a symbolic answer: ${meaning} It is a conversation prompt, not a measurement of the chance of success.`
    : `A theme to consider: ${meaning} Look for a concrete example and a counterexample before acting.`;
}
